module.exports = __webpack_public_path__ + "img/minus.1fca1edb.svg";